export default "__VITE_ASSET__XKhnVVyL__"